module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-24-65fe5d76eb2cd8cc0cfbd3ded69c2a40.jpg";